import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';
import { fromJS, List } from 'immutable';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import { inviteUser } from 'redux/modules/briefDetails';
import { setSuccessMessage } from 'redux/modules/successMessage';
import { loadOwnBriefs, isOwnBriefsLoaded } from 'redux/modules/portfolio';

import {
  filter,
  getFilterHash,
  getFilterFromQS,
  isFilterSet,
} from 'redux/modules/browse';

import BrowseEmpty from 'components/Browse/Results/BrowseEmpty';
import BrowseUserCard from 'components/Browse/UserCard/BrowseUserCard';
import BrowseUserCard2 from 'components/Browse/UserCard/BrowseUserCard2';
import BrowsePlaceholder from 'components/Browse/Placeholder/BrowsePlaceholder';

import { INVITE_SENT_SUCCESS } from 'constants/successMessages';
import NoAuthResultsMessage from 'components/Shared/NoAuthResultsMessage/NoAuthResultsMessage';
import { trackEvent } from 'helpers/Analytics';
import styles from './BrowseResults.module.scss';

@connect(
  (state) => ({
    user: state.auth.user,
    filterResults: fromJS(state.browse.filterResults),
    filteredUserEntities: fromJS(state.entities.filteredUsers),
    portfolio: fromJS(state.portfolio),
    ownBriefs: state.auth.ownBriefs,
    briefEntities: state.entities.briefs,
    globalState: state,
  }),
  {
    filter,
    inviteUser,
    setSuccessMessage,
    loadOwnBriefs,
  }
)
export default class BrowseResults extends Component {
  componentDidMount = () => {
    const {
      location,
      filter: getFilterResults,
      filterResults,
      user: loggedInUser,
      loadOwnBriefs,
    } = this.props;

    // Load user's own briefs if logged in
    if (loggedInUser) {
      loadOwnBriefs(loggedInUser.username);
    }

    const filter = getFilterFromQS(location);
    const hash = getFilterHash(filter);

    const haveFilterResultsLoaded = filterResults.getIn(
      [hash, 'loaded'],
      false
    );
    const areResultsLoading = filterResults.getIn([hash, 'loading'], false);

    // Fetch filter results
    if (!haveFilterResultsLoaded && !areResultsLoading) {
      getFilterResults(filter);
    }
  };

  componentDidUpdate(prevProps) {
    const { location: oldLocation } = prevProps;
    const { location: newLocation } = this.props;

    const filterHasChanged = oldLocation.search !== newLocation.search;

    if (filterHasChanged) {
      const { filter: getFilterResults, filterResults } = this.props;

      const filter = getFilterFromQS(newLocation);
      const hash = getFilterHash(filter);

      const hasLoaded = filterResults.getIn([hash, 'loaded'], false);
      const isLoading = filterResults.getIn([hash, 'loading'], false);
      const totalPages = filterResults.getIn([hash, 'totalPages'], 0);
      const browsePage =
        newLocation.query && newLocation.query.page
          ? newLocation.query.page
          : '';

      if (browsePage !== '' && totalPages !== 0) {
        trackEvent('user-lands-on-browse', {
          browse_page: browsePage,
          total_browse_pages: totalPages,
        });
      }

      if (browsePage === '1' && totalPages === 0) {
        const filterData = {
          role: filter.role ? filter.role : '-',
          skill: filter.skill ? filter.skill : '-',
          location: filter.location ? filter.location : '-',
          min_day_rate: filter.minDayRate ? filter.minDayRate : '-',
          max_day_rate: filter.maxDayRate ? filter.maxDayRate : '-',
        };
        trackEvent('browse-no-results', { filterData });
      }

      // Fetch filter results
      if (!hasLoaded && !isLoading) {
        getFilterResults(filter);
      }
    }
  }

  handleInvite = (brief, user) => {
    const { inviteUser, setSuccessMessage, user: loggedInUser } = this.props;

    trackEvent('user-invites-freelancer', {
      type: 'browse',
      loggedIn: !!loggedInUser,
      userType: loggedInUser ? loggedInUser.type : 'guest',
    });

    inviteUser(loggedInUser, user.id, brief)
      .then(() => {
        this.props.setSuccessMessage(INVITE_SENT_SUCCESS);
      })
      .catch(() => {});
  };

  render() {
    const {
      filterResults,
      filteredUserEntities,
      location,
      user: loggedInUser,
      portfolio,
      ownBriefs,
      briefEntities,
      globalState,
    } = this.props;

    const filter = getFilterFromQS(location);
    const hash = getFilterHash(filter);
    const isLoading = filterResults.getIn([hash, 'loading'], false);

    let results = filterResults.getIn([hash, 'results'], List());
    if (!loggedInUser) {
      results = results.slice(0, 15);
    }

    const collaborations = ownBriefs.collaborations
      .map((briefId) => briefEntities[briefId])
      .filter(Boolean);

    // Get loading state for own briefs - show loading while actively loading or until we have all collaborations
    const isLoadingOwnBriefs =
      loggedInUser &&
      (portfolio.getIn([loggedInUser.username, 'loadingOwnBriefs'], false) ||
        !isOwnBriefsLoaded(globalState, loggedInUser.username));

    const totalResults = filterResults.getIn([hash, 'total'], 0);

    return (
      <Row className={!isFilterSet(filter) && styles.centerPlaceholder}>
        {!isFilterSet(filter) && <BrowsePlaceholder />}

        {isFilterSet(filter) &&
          isLoading &&
          _.times(12, (i) => (
            <Col key={`col|${i.toString()}`} xs={12} sm={6} md={6} lg={4}>
              <BrowseUserCard key={`plchldr-${i.toString()}`} user={null} />
            </Col>
          ))}

        {isFilterSet(filter) && !isLoading && totalResults === 0 && (
          <BrowseEmpty />
        )}

        {isFilterSet(filter) &&
          !isLoading &&
          results
            .map((user) => filteredUserEntities.get(user.toString()))
            .map((user) => (
              <Col key={`${hash}|${user.get('id')}`} xs={12}>
                <BrowseUserCard2
                  collaborations={collaborations}
                  onInvite={this.handleInvite}
                  user={user.toJS()}
                  preferredRole={filter?.role}
                  isLoadingOwnBriefs={isLoadingOwnBriefs}
                />
              </Col>
            ))}
        {isFilterSet(filter) && totalResults > 0 && !loggedInUser && (
          <Col className="no-padding" xs={12}>
            <div style={{ filter: 'blur(7px)' }}>
              {[...Array(1)].map((_, idx) => (
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  mdHidden={idx === 2}
                  smHidden={idx !== 0}
                  xsHidden={idx !== 0}
                  key={`loading_creative_${idx}`}
                >
                  <BrowseUserCard2 user={null} />
                </Col>
              ))}
            </div>
            <NoAuthResultsMessage location={location} />
          </Col>
        )}
      </Row>
    );
  }
}

BrowseResults.propTypes = {
  location: PropTypes.object,
  ownBriefs: PropTypes.object,
  briefEntities: PropTypes.object,
  portfolio: PropTypes.object,
  inviteUser: PropTypes.func,
  setSuccessMessage: PropTypes.func,
  filter: PropTypes.func,
  filterResults: PropTypes.any,
  filteredUserEntities: PropTypes.object,
  loadOwnBriefs: PropTypes.func,
};
